var model = "";
var windowWidth;
if("undefined" != typeof wx && wx.getSystemInfoSync) {
    var { model,windowWidth } = wx && wx.getSystemInfoSync() ? wx.getSystemInfoSync() : {};
}
// fix 刘海屏
const isIPX = (
    model.indexOf('iPhone X') > -1 || 
    model.indexOf('iPhone XR') > -1 || 
    model.indexOf('iPhone 12') > -1 || 
    model.indexOf('iPhone 13') > -1 || 
    model.indexOf('iPhone12') > -1 || 
    model.indexOf('iPhone13') > -1
)
const setTitle = (title)=>{
    if(!title || typeof title != "string") return;
    title = title || "";
    if("undefined" != typeof wx && wx.getSystemInfoSync) {
        wx.setNavigationBarTitle({title})
    } else {
        document.title = title;
    } 
}

export {
    isIPX,
    setTitle,
    windowWidth
}